import { render } from "./LabResultTrend.vue?vue&type=template&id=07b77b08"
import script from "./LabResultTrend.js?vue&type=script&lang=js"
export * from "./LabResultTrend.js?vue&type=script&lang=js"

import "./LabResultTrend.vue?vue&type=style&index=0&id=07b77b08&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__